export const getTotalPages = (pageSize: number, totalEntityCount: number) =>
  Math.ceil(totalEntityCount / pageSize);
